import { NavLink } from 'react-router-dom';
import {
  House, Package, BookOpen, LayoutGrid, ShoppingCart,
  CalendarDays, BarChart2, Wand2, Wallet,
  Activity, Dumbbell, Calendar, TrendingUp,
  Users, Compass, User,
  ClipboardList, Award, Bot, BookMarked, MessageSquare, CreditCard, Settings,
  Sun, Moon,
} from 'lucide-react';
import { TIERS, isRouteAllowed } from '../config/tiers';
import { getLocalEarnedMarks, getHighestRank } from '../utils/marks';

const NAV_GROUPS = [
  {
    label: 'Kitchen',
    links: [
      { to: '/', label: 'Home',      icon: House,        end: true },
      { to: '/inventory',    label: 'Inventory',  icon: Package },
      { to: '/recipes',      label: 'Recipes',    icon: BookOpen },
      { to: '/catalog',      label: 'Catalog',    icon: LayoutGrid },
      { to: '/shopping-list',label: 'Shopping',   icon: ShoppingCart },
    ],
  },
  {
    label: 'Nutrition',
    links: [
      { to: '/meal-planner',    label: 'Meal Plan',   icon: CalendarDays },
      { to: '/macro-planner',   label: 'Macros',      icon: BarChart2 },
      { to: '/meal-synthesizer',label: 'Synthesizer', icon: Wand2 },
      { to: '/budget',          label: 'Budget',      icon: Wallet },
    ],
  },
  {
    label: 'Protocol',
    links: [
      { to: '/biometrics',          label: 'Biometrics', icon: Activity },
      { to: '/workout-protocol',    label: 'Workout',    icon: Dumbbell },
      { to: '/calendar',            label: 'Calendar',   icon: Calendar },
      { to: '/progressive-overload',label: 'Overload',   icon: TrendingUp },
    ],
  },
  {
    label: 'Community',
    links: [
      { to: '/community', label: 'Feed',       icon: Users },
      { to: '/discover',  label: 'Discover',   icon: Compass },
      { to: '/profile',   label: 'My Profile', icon: User },
    ],
  },
  {
    label: 'Tools',
    links: [
      { to: '/fitness',   label: 'Fitness Log',      icon: ClipboardList },
      { to: '/brigade',   label: 'Brigade',           icon: Award },
      { to: '/ai-recipe', label: 'Recipe AI',         icon: Bot },
      { to: '/blog',      label: 'Protocol Library',  icon: BookMarked },
      { to: '/feedback',  label: 'Feedback',          icon: MessageSquare },
      { to: '/upgrade',   label: 'Plans',             icon: CreditCard },
      { to: '/settings',  label: 'Settings',          icon: Settings },
    ],
  },
];

const Navbar = ({ darkMode, setDarkMode, sidebarOpen, closeSidebar, tier }) => {
  const handleLinkClick = () => {
    if (window.innerWidth < 768) closeSidebar();
  };

  const tierConfig = TIERS[tier] || TIERS.commis;
  const earnedIds = getLocalEarnedMarks();
  const rank = getHighestRank(earnedIds);

  return (
    <nav
      className={`app-nav${sidebarOpen ? '' : ' nav-collapsed'}`}
      role="navigation"
      aria-label="Main navigation"
      aria-hidden={!sidebarOpen}
    >
      {NAV_GROUPS.map((group) => (
        <div key={group.label} className="nav-group">
          <div className="nav-group-label">{group.label}</div>
          <ul className="nav-list">
            {group.links.map(({ to, label, icon: Icon, end }) => {
              const allowed = isRouteAllowed(tier, to);
              return (
                <li key={to}>
                  <NavLink
                    to={to}
                    end={end}
                    className={({ isActive }) =>
                      `nav-link${isActive ? ' active' : ''}${!allowed ? ' nav-link-locked' : ''}`
                    }
                    onClick={handleLinkClick}
                    tabIndex={sidebarOpen ? 0 : -1}
                  >
                    <Icon size={15} aria-hidden="true" className="nav-link-icon" />
                    <span>{label}</span>
                    {!allowed && <span className="nav-lock-badge">PRO</span>}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
      ))}

      <div className="nav-footer">
        <NavLink
          to="/brigade"
          className="nav-rank-badge"
          onClick={handleLinkClick}
          tabIndex={sidebarOpen ? 0 : -1}
        >
          <span className="nav-rank-name">{rank ? rank.name : tierConfig.name}</span>
          <span className="nav-rank-count">{earnedIds.length} marks</span>
        </NavLink>
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="btn-theme-toggle"
          aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          tabIndex={sidebarOpen ? 0 : -1}
        >
          <span>{darkMode ? 'Light Mode' : 'Dark Mode'}</span>
          {darkMode
            ? <Sun size={14} aria-hidden="true" />
            : <Moon size={14} aria-hidden="true" />
          }
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
